import { hasLoggedInTimestamp, readLoginSnapshot } from '../cookies/loginState';
import { watchLoginState } from '../cookies/watchLoginState';
import { useAuthStore } from '../store';

let stopWatchingCookie: (() => void) | null = null;

export function syncAuthStoreFromCookies() {
  useAuthStore.getState().setLoginSnapshot(readLoginSnapshot(), hasLoggedInTimestamp());
}

export function startAuthPolling(intervalMs?: 1000) {
  if (stopWatchingCookie) {
    return;
  }

  stopWatchingCookie = watchLoginState((change) => {
    if (
      change.previousLoginStateRawValue !== change.nextLoginStateRawValue ||
      change.previousLoggedInTimestampRawValue !== change.nextLoggedInTimestampRawValue
    ) {
      syncAuthStoreFromCookies();
    }
  }, intervalMs);
}

export function stopAuthPolling() {
  stopWatchingCookie?.();
  stopWatchingCookie = null;
}
